// ============================================================================
// ISOMORPHIC SCHEMAS INDEX
// Schemas shared between frontend and backend (camelCase)
// ============================================================================

// Shared utilities (export first to avoid conflicts)
export * from "./common";
export * from "./ai";

// Main entities (with CREATE/UPDATE)
export * from "./workflow";
export * from "./agent";
export * from "./phase";
export * from "./knowledge-base";
export * from "./patient";
export * from "./follow-up";
export * from "./follow-up-snapshots";
export * from "./profile";
export * from "./workspace";
export * from "./user";

// System entities (read-only, no CREATE/UPDATE)
export * from "./agent-test-call";
export * from "./call-session";
export * from "./call-attempt";
export * from "./call-review";
export * from "./triggered-alert";
export * from "./triggered-alert-action";
export * from "./triggered-condition";
export * from "./audit-log";
export * from "./publication";
export * from "./dashboard";

// Call-related entities (export before retell-call-output to avoid conflicts)
export * from "./call-participant";
export * from "./recording";
export * from "./transcript-segment";
export * from "./collected-answer";
export * from "./call-analysis"; // Export before retell-call-output
export * from "./retell-call-output"; // Has internal CallAnalysisSchema (not exported as type)
export * from "./retell-webhook-event";
